<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-9-contact-part-2">
<h1>Chapter 9<br/> Contact Part 2</h1>
<p>Dax is cleaning himself on the console, and we hear his stomach gurgling. “Oh, no.”</p>
<p>Dax runs from the room, heading for the litter tray.</p>
<p>As he runs out of the bridge, Zorn calls out, “Dax, get us out of here.”</p>
<p>When nothing happens, and Bjorn and Zorn realise they are stranded, they dive through the legs of the crowds, and run for their lives.</p>
<p>“Change into human form. We will be less conspicuous,” says Bjorn.</p>
<p>“On it,” says Zorn.</p>
<p>They both shape-shift into human form and keep running. Unfortunately, for Bjorn and Zorn, a member of both crowds witnesses the change and continues the chase. “That guy there, after him,” yells a member of the crowd.</p>
<p>As they run, they continue trying to contact Dax.</p>
<br/>
<p style="text-align: center;">***</p><br/>
<p>Bjorn becomes trapped against the Wailing Wall, and they chase Zorn into the Statue of Liberty.</p>
<p>Bjorn and Zorn continue to call out, “Dax, teleport us out. Where are you?”</p>
<p>Suddenly, to their relief, they hear Florence’s voice, “Mr Dax is not available. How may I help you?”</p>
<p>They both scream, “Hit the red button!”</p>
<p>Florence hits the red button, and a second alien ship appears. General Flax appears on the main screen, along with an orange cat called Brax.</p>
<p>“What’s the problem?” asks Flax.</p>
<p>“Bjorn and Zorn are on the surface, and in trouble,” cries Florence.</p>
<p>Meanwhile, Bjorn and Zorn simultaneously take the form of Ptoni the pteranodon, and fly from their captors. As they take to the skies, they disappear into thin air. At that moment, a gunshot is heard, and Zorn is hit in the shoulder. Bjorn and Zorn materialise on the second ship, Zorn is bleeding heavily from his wound.</p>
<p>“Are they OK?” asks Florence with tears pouring down her face.</p>
<p>Dax re-enters the bridge. “What’s happening?”</p>
<p>“You almost killed Bjorn and Zorn, that’s what’s happening,” screams Florence.</p>
<p>“What?” asks Dax, puzzled.</p>
<p>“The humans turned nasty, and they needed to get out quickly because you weren’t here. They were chased and attacked,” screams Florence.</p>
<p>Zorn changes back to his normal form.</p>
<p>“It’s OK, I got shot, but a simple shape-shift takes away the blood vessels so I can’t bleed. It’s OK, cat, it’s all good.”</p>
<p>“Sorry, but when you gotta go, you gotta go,” says Dax.</p>
<p>Bjorn, turning to Brax and Flax, says, “Come and meet our new friends.” Bjorn, Zorn, Brax, and Flax transfer to the Z3.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch013.vue?1fe3c1fa